const addResourceType = (array, resourceType) => array.map(obj => {
  obj.resourceType = resourceType
  return obj
})

const getters = {
  isResourcesLoaded: (state) => state.loaded,
  loadingResources: (state) => state.loadingResources,
  loadingResource: (state) => state.loadingResource,
  getResourceUrl: (state) => (resourceType, resourceId) => {
    console.log(state[resourceType])
    const resource = state[resourceType].find(item => Number(item.id) === Number(resourceId))
    console.log(resource)
    return resource ? resource.url : null
  },
  getMaterialPortalResource: (state) => state.materialPortalResource,
  getProtectionResources: (state) => {
    return addResourceType(state.ppe, 'ppe')
  },
  getDecontaminationResources: (state) => {
    return addResourceType(state.decontamination, 'decontamination')
  },
  getSamplingResources: (state) => {
    return addResourceType(state.sampling_type, 'sampling_type')
  },
  getManualResources: (state) => {
    return addResourceType(state.detector, 'detector')
  },
}

export default getters
